export default defineNuxtPlugin(() => {
  // Facebook Pixel을 안전하게 초기화하는 함수
  const initFacebookPixel = () => {
    try {
      // fbq가 이미 존재하는지 확인
      if (typeof window.fbq !== 'undefined') {
        return;
      }

      // Facebook Pixel 초기화 스크립트 (안전성 검사 포함)
      (function(f: any, b: Document, e: string, v: string, n: any, t: HTMLScriptElement, s: HTMLScriptElement | null) {
        if (f.fbq) return;
        
        n = f.fbq = function() {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        
        t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        
        // 안전한 DOM 삽입
        s = b.getElementsByTagName(e)[0] as HTMLScriptElement;
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          // fallback: head에 직접 추가
          b.head.appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      // Facebook Pixel 초기화 및 PageView 추적
      if (typeof window.fbq !== 'undefined') {
        window.fbq('init', '1619103288922963');
        window.fbq('track', 'PageView');
      }
    } catch (error) {
      console.warn('Facebook Pixel 초기화 중 오류 발생:', error);
    }
  };

  // DOM이 완전히 로드된 후 실행
  if (process.client) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFacebookPixel);
    } else {
      // DOM이 이미 로드된 경우 즉시 실행
      initFacebookPixel();
    }
  }
});

// TypeScript 타입 선언
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
